import { Wrapper } from '@american-autonomy/ag-ui';

import CartPanel from 'pages/MaintenancePage/components/CartPanel';
import EditServiceRecordPanel from 'pages/MaintenancePage/components/EditServiceRecordPanel';
import LogServicePanel from 'pages/MaintenancePage/components/LogServicePanel';
import ServiceIntervalConfigPanel from 'pages/MaintenancePage/components/ServiceIntervalConfigPanel';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

// Overlay cluster for the page's modal panels. Every panel renders fixed-position
// chrome, so the wrapper is layout-inert.
const MaintenancePanels: FunctionComponent<Props> = ({
    className = '',
    data,
    showCart,
    testId = TEST_ID
}) => (
    <Wrapper className={className} testId={testId}>
        {showCart && (
            <CartPanel
                cart={data.cart}
                isOpen={data.isCartOpen}
                itemCount={data.cartItemCount}
                onClose={data.handleCloseCart}
                onDecrement={data.handleDecrementCartLine}
                onIncrement={data.handleIncrementCartLine}
                onPlaceOrder={data.handlePlaceOrder}
                onRemove={data.handleRemoveCartLine}
                orderPoNumber={data.orderPoNumber}
                subtotal={data.cartSubtotal}
            />
        )}

        <ServiceIntervalConfigPanel
            configModel={data.configModel}
            isAdmin={data.isAdmin}
            isOpen={data.isIntervalConfigOpen}
            onClose={data.handleCloseIntervalConfig}
            onModelChange={data.setConfigModel}
            onSave={data.handleSaveIntervals}
            serviceIntervals={data.configServiceIntervals}
        />

        <LogServicePanel
            drone={data.logServiceDrone}
            isOpen={data.isLogServiceOpen}
            onClose={data.handleCloseLogService}
            onSave={data.logService}
            onSetAirworthy={data.setAirworthy}
            serviceIntervals={data.serviceIntervals}
        />

        <EditServiceRecordPanel
            isOpen={data.isEditServiceOpen}
            onClose={data.handleCloseEditService}
            onSave={data.handleSaveEditService}
            record={data.editServiceRecord}
        />
    </Wrapper>
);

export default MaintenancePanels;
